import { render, staticRenderFns } from "./StepIdentification.vue?vue&type=template&id=4b54f28b&"
import script from "./StepIdentification.vue?vue&type=script&lang=js&"
export * from "./StepIdentification.vue?vue&type=script&lang=js&"
import style0 from "./StepIdentification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b54f28b')) {
      api.createRecord('4b54f28b', component.options)
    } else {
      api.reload('4b54f28b', component.options)
    }
    module.hot.accept("./StepIdentification.vue?vue&type=template&id=4b54f28b&", function () {
      api.rerender('4b54f28b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/oficialNumeration/StepIdentification.vue"
export default component.exports